// extracted by mini-css-extract-plugin
module.exports = {"input":"Password_input__1IZFs","input-password":"Password_input-password__aTqCW"};